export const QUERY_KEYS = {
  ME: 'me',
} as const;
